
<template>
     <a-select show-search :value="value" placeholder="输入IP搜索"  allow-clear style="width: 100%;"
         :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="fetching ? undefined : null"
         @search="handleSearch" @change="handleChange" @focus="doSearch">
         <a-spin v-if="fetching" slot="notFoundContent" size="small" />
         <a-select-option v-for="d in data" :key="d.value">
             {{ d.text }}
         </a-select-option>
     </a-select>
</template>
<script>

export default {
    data() {
        return {
            data: [],
            searchTimmer:null,
            value:undefined,
            fetching:false
        }
    },

    props:{
        searchTimeRange:String,
        selectedAppcode:String,
        selectedInvokeappcode:String,
    },

    methods: {
    
        handleChange(value) {
            this.value = value;
            console.log(value)
            this.$emit('onIPChange',value);
        },
        handleSearch(value) {
            let that = this;
            if(value.length <= 3){
                return
            }
            if(that.searchTimmer){
                return
            }
            else{
                that.searchTimmer = setTimeout(() => {
                    that.doSearch(value);
                }, 800);
            }
        },

        doSearch(value){
            let that = this;
            let starttime = (new Date().getTime())/1000;
            let endtime = (new Date().getTime())/1000;
            let whereStr = " where 1=1 ";
            starttime = (new Date(this.searchTimeRange.split('~')[0]).getTime())/1000;
            endtime = (new Date(this.searchTimeRange.split('~')[1]).getTime())/1000;
            if(this.selectedAppcode){
                whereStr += "and AppCode = '" + this.selectedAppcode + "' ";
            }
            if(this.selectedInvokeappcode){
                whereStr += "and invokeappcode = '" + this.selectedInvokeappcode + "' ";
            }

            if(value){
                whereStr += "and clientip like '%"+value+"%' ";
            }

            let queryStr = "* | select clientip from log " + whereStr + " group by clientip"
            that.fetching = true;
            
            let params = {
                projectname:that.G.getServiceMonitorName(),
                logstorename:'service-monitor',
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:50,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.data = [];
                    let result = res.data.data.list;
                    result.forEach(r => {
                        that.data.push({
                            value: r.clientip,
                            text: r.clientip,
                        });
                    });
                }
                clearTimeout(that.searchTimmer)
                that.searchTimmer = null;
                that.fetching = false;
            }).catch(() => {
                clearTimeout(that.searchTimmer)
                that.searchTimmer = null;
                that.fetching = false;

            });
        },

        setDefaultValue(defaultValue){
            this.value = defaultValue;
            this.$emit('onIPChange',defaultValue);
        }
    },
    mounted(){
    },

};
</script>

<style scoped>

</style>
